export default __webpack_public_path__ + "static/media/hander.106e6cee.png";